import { ReactComponent as HomeSVG } from "../assets/Home.svg";
import { ReactComponent as InfoSVG } from "../assets/info.svg";
import { ReactComponent as BookSVG } from "../assets/book.svg";
import { ReactComponent as MapSVG } from "../assets/map.svg";
import { ReactComponent as ChartSVG } from "../assets/chart.svg";
import { ReactComponent as ShieldSVG } from "../assets/shield.svg";
import { ReactComponent as HamburgerSVG } from "../assets/hamburger.svg";

import {
  useWeb3ProviderDispatch,
  useWeb3ProviderState,
} from "../contexts/Web3Provider";
import {
  useRoutingProviderDispatch,
  useRoutingProviderState,
} from "../contexts/RoutingProvider";
import {
  useUIProviderState,
  useUIProviderDispatch,
} from "../contexts/UIProvider";
import { useEffect } from "react";
import { motion } from "framer-motion";
import { useMediaQuery } from "react-responsive";
import { stopPropagation } from "../assets/constants";

export default function LeftNav() {
  const routeDispatch = useRoutingProviderDispatch();
  const routeState = useRoutingProviderState();
  const uiState = useUIProviderState();
  const uiDispatch = useUIProviderDispatch();
  console.log(routeState);
  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });

  function determineNavBar() {
    if (isMobile) {
      if (uiState.menuShowing) {
        return {
          x: 0,
        };
      } else {
        return {
          x: -300,
        };
      }
    } else {
      return {
        x: 0,
      };
    }
  }
  return (
    <motion.div
      animate={determineNavBar()}
      style={{ zIndex: 10 }}
      className={`leftNavContainer gradientBorder`}
      onClick={stopPropagation}
      onTouchMove={stopPropagation}
      onMouseDown={stopPropagation}
    >
      {isMobile && (
        <div
          style={{
            position: "absolute",
            top: 4,
            right: 4,
            width: 13,
            height: 13,
            zIndex: 20,
            color: "white",
          }}
          onClick={() => {
            uiDispatch({ type: "TOGGLE_MENU_VISIBLE" });
          }}
        >
          <HamburgerSVG />
        </div>
      )}
      <div className={"navImageContainer"}></div>
      <div className={`leftNavModal gradientBackground`}>
        <div className={"navItemsContainer"}>
          <div
            className={"navItem"}
            onClick={() => {
              routeDispatch({ type: "SWITCH_ROUTE", payload: "HOME" });
            }}
          >
           <div className={"navIconContainer"}>
              <HomeSVG className={"navIcon"} />
            </div>
            <span className={"navLabel"}>
              <b>HOME</b>
            </span>
          </div>
          <div
            className={"navItem"}
            onClick={() => {
              routeDispatch({ type: "SWITCH_ROUTE", payload: "FAQ" });
            }}
          >
            <div className={"navIconContainer"}>
               <InfoSVG className={"navIcon"} />
            </div>
            <span className={"navLabel"}>
              <b>FAQ</b>
            </span>
          </div>
          <div
            className={"navItem"}
            onClick={() => {
              routeDispatch({ type: "SWITCH_ROUTE", payload: "WHITEPAPER" });
            }}
          >
           <div className={"navIconContainer"}>
              <BookSVG className={"navIcon"} />
            </div>
            <span className={"navLabel"}>
              <b>WHITEPAPER</b>
            </span>
          </div>
          <div
            className={"navItem"}
            onClick={() => {
              routeDispatch({ type: "SWITCH_ROUTE", payload: "SOCIAL" });
            }}
          >
          <div className={"navIconContainer"}>
             <MapSVG className={"navIcon"} />
            </div>
            <span className={"navLabel"}>
              <b>SOCIAL</b>
            </span>
          </div>
          <div
            className={"navItem"}
            onClick={() => {
              routeDispatch({ type: "SWITCH_ROUTE", payload: "CHART" });
            }}
          >
          <div className={"navIconContainer"}>
              <ChartSVG className={"navIcon"} />
            </div>
            <span className={"navLabel"}>
              <b>CHART</b>
            </span>
          </div>
          <div
            className={"navItem"}
            onClick={() => {
              routeDispatch({ type: "SWITCH_ROUTE", payload: "DAPP" });
            }}
          >
            <div className={"navIconContainer"}>
              <ShieldSVG className={"navIcon"} />
            </div>
            <span className={"navLabel"}>
              <b>DAPP</b>
            </span>
          </div>
        </div>

        <ConnectWalletButton />
      </div>
    </motion.div>
  );
}

function ConnectWalletButton() {
  const web3Dispatch = useWeb3ProviderDispatch();
  const web3State = useWeb3ProviderState();

  async function clearWallet() {
    await web3State.web3Modal.resetState();
    await web3State.web3Modal.clearCachedProvider();
    web3Dispatch({ type: "UPDATE_CURRENT_WALLET", payload: "" });
  }

  async function triggerWeb3Modal() {
    const provider = await web3State.web3Modal.connect();
    web3Dispatch({ type: "UPDATE_WALLET_PROVIDER", payload: provider });

    provider.on("accountsChanged", (accounts: string[]) => {
      console.log(accounts);
      web3Dispatch({ type: "UPDATE_CURRENT_WALLET", payload: accounts[0] });
    });

    // Subscribe to chainId change
    provider.on("chainChanged", (chainId: number) => {
      console.log(chainId);
    });

    // Subscribe to provider connection
    provider.on("connect", (info: { chainId: number }) => {
      console.log("CONNECTED", info);
    });

    // Subscribe to provider disconnection
    provider.on("disconnect", (error: { code: number; message: string }) => {
      console.log(error);
    });
  }

  useEffect(() => {}, []);

  const { currentWallet } = web3State;
  const walletBegin = currentWallet.substring(0, 5);
  const walletEnd = currentWallet.substring(
    currentWallet.length - 5,
    currentWallet.length
  );
  const formattedWallet = `${walletBegin}...${walletEnd}`;
  return (
    <div className={"leftNavBottom"}>
      {web3State.currentWallet ? (
        <span>{formattedWallet}</span>
      ) : (
        <span onClick={triggerWeb3Modal}>Connect Wallet</span>
      )}
      {web3State.currentWallet && <span onClick={clearWallet}>DISCONNECT</span>}
    </div>
  );
}
